import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type BaseSlideControlClasses = 'backArrow' | 'forwardArrow' | 'baseArrow' | 'disabledArrow';

const baseSlideControlStyles = makeStyles<ISpcTheme, BaseSlideControlClasses>(
  () => ({
    baseArrow: {
      position: 'absolute',
      zIndex: 40,
    },
    backArrow: {
      left: 0,
      '& svg': {
        position: 'relative',
        left: 5,
      },
    },
    forwardArrow: {
      right: 0,
    },
    disabledArrow: {
      display: 'none',
    },
  }),
  { name: 'GqlStockLite_BaseSlideControl' },
);

export default baseSlideControlStyles;
